import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class Transcripts {

  #rmp;
  #transcriptsData = {};
  #loadedTranscript = [];

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #onItemInteraction(event) {
    if (event && event.target) {
      const start = event.target.getAttribute('data-start-time');
      const startMS = FW.dateToSeconds(start) * 1000;
      Logger.print('transcripts', 'interaction with rmp-transcripts-item: ' + startMS + ' ms');
      this.#rmp.seekTo(startMS).catch(error => {
        this.#rmp.rmpUtils.warning(1016, error);
      });
    }
  }

  #updateSideMenuMaxHeight() {
    const transcriptsSideMenu = this.#rmp.dom.transcriptsContainer.querySelector('.rmp-transcripts-side-menu');
    if (transcriptsSideMenu) {
      transcriptsSideMenu.style.maxHeight = this.#rmp.getPlayerSize().height + 'px';
      transcriptsSideMenu.classList.remove('rmp-xs', 'rmp-sm', 'rmp-md');
      if (this.#rmp.dom.container.classList.contains('rmp-md')) {
        transcriptsSideMenu.classList.add('rmp-md');
      } else if (this.#rmp.dom.container.classList.contains('rmp-sm')) {
        transcriptsSideMenu.classList.add('rmp-sm');
      } else if (this.#rmp.dom.container.classList.contains('rmp-xs')) {
        transcriptsSideMenu.classList.add('rmp-xs');
      }
    }
  }

  #onSelectChange(event) {
    const lng = event.target.value;
    const index = this.#loadedTranscript.findIndex(transcript => transcript.lng === lng);
    const transcriptsBody = this.#rmp.dom.transcriptsContainer.querySelector('.rmp-transcripts-body');
    transcriptsBody.innerHTML = this.#loadedTranscript[index].html;
  }

  #setUpTranscriptsUI() {
    const transcriptsSideMenu = FW.createElement('div', `rmp-transcripts-side-menu rmp-color-button rmp-${this.#rmp.skin}`);
    const transcriptsHeader = FW.createElement('div', 'rmp-transcripts-header', this.#rmp.labels.hint.transcript, this.#rmp.rtl);
    const transcriptsSelect = FW.createElement('select', 'rmp-select rmp-transcripts-select');
    transcriptsSelect.setAttribute('id', 'transcript-language-select');
    transcriptsSelect.setAttribute('name', 'transcript-language-select');
    transcriptsSideMenu.appendChild(transcriptsHeader);
    transcriptsSideMenu.appendChild(transcriptsSelect);
    const transcriptsBody = FW.createElement('div', 'rmp-transcripts-body');
    transcriptsBody.addEventListener('click', this.#onItemInteraction.bind(this));
    for (let i = 0, len = this.#loadedTranscript.length; i < len; i++) {
      const name = this.#loadedTranscript[i].name;
      const lng = this.#loadedTranscript[i].lng;
      const optionElement = FW.createElement('option', 'rmp-option', name);
      optionElement.setAttribute('value', lng);
      transcriptsSelect.appendChild(optionElement);

      const transcriptData = this.#transcriptsData[lng];
      for (let j = 0, len = transcriptData.length; j < len; j++) {
        this.#loadedTranscript[i].html +=
          '<span data-start-time="' + transcriptData[j].start +
          '" data-end-time="' + transcriptData[j].end +
          '" data-cue-settings="' + transcriptData[j].cueSettings +
          '" class="rmp-transcripts-item">' + transcriptData[j].text +
          '</span>';
      }

    }

    transcriptsBody.innerHTML = this.#loadedTranscript[0].html;
    transcriptsSideMenu.appendChild(transcriptsBody);
    this.#rmp.dom.transcriptsContainer.appendChild(transcriptsSideMenu);
    // transcriptsSelect
    transcriptsSelect.addEventListener('change', this.#onSelectChange.bind(this));
    // set max height for rmp-transcripts-side-menu
    this.#updateSideMenuMaxHeight();
    this.#rmp.on('resize', this.#updateSideMenuMaxHeight.bind(this));
  }

  #parseTranscriptsVtt(transcripts) {
    const data = transcripts.data;
    const lng = transcripts.lng;
    const lines = data.split(/(\r\n|\r|\n)/g);
    const re1 = /^\s*$/;
    const vttArray = [];
    for (let i = 0, len = lines.length; i < len; i++) {
      if (!re1.test(lines[i])) {
        vttArray.push(lines[i]);
      }
    }
    Logger.print('transcripts', 'raw vttArray follows', vttArray);
    const re2 = /WEBVTT/i;
    if (!re2.test(vttArray[0])) {
      this.#rmp.rmpUtils.warning(5001);
      return;
    }
    vttArray.shift();
    this.#transcriptsData[lng] = [];
    const re3 = /^\s*\d*?:?\d*?:?\d+(\.\d+)?\s*-->\s*\d*?:?\d*?:?\d+(\.\d+)?(\s*|\s+.+)$/;
    const re4 = /^\d+$/;
    for (let i = 0, len = vttArray.length; i < len; i++) {
      if (vttArray[i] && vttArray[i + 1] && re3.test(vttArray[i])) {
        const splitTime = (vttArray[i]).split('-->');
        const start = (splitTime[0]).trim();
        let end = (splitTime[1]).trim();
        const splitEndCueSettings = end.split(' ');
        end = splitEndCueSettings[0];
        let cueSettings = '';
        if (splitEndCueSettings.length > 1) {
          for (let i = 1, len = splitEndCueSettings.length; i < len; i++) {
            cueSettings += splitEndCueSettings[i];
            if (i !== len - 1) {
              cueSettings += '_';
            }
          }
        }
        let text = vttArray[i + 1];
        if (vttArray[i + 2] && !re4.test(vttArray[i + 2])) {
          text += ' ' + vttArray[i + 2];
          if (vttArray[i + 3] && !re4.test(vttArray[i + 3])) {
            text += ' ' + vttArray[i + 3];
          }
        }
        if (splitTime.length === 2) {
          this.#transcriptsData[lng].push({
            start,
            end,
            text,
            cueSettings
          });
        }
      }
    }
    if (this.#transcriptsData[lng].length === 0) {
      this.#rmp.rmpUtils.warning(5001);
      return;
    }
    Logger.print('transcripts', 'parsed VTT file', this.#transcriptsData[lng]);
  }

  #ajaxCall(i) {
    return new Promise((resolve, reject) => {
      const transcriptUri = this.#rmp.transcripts[i].uri;
      FW.ajax(transcriptUri, this.#rmp.ajaxWithCredentials, 'GET').
        then(data => {
          Logger.print('captions', `loaded WebVTT file at ${transcriptUri}`);
          if (typeof data === 'string') {
            let defaultTranscript = false;
            if (this.#rmp.transcripts[i].default) {
              defaultTranscript = true;
            }
            this.#loadedTranscript[i] = {
              lng: this.#rmp.transcripts[i].lng,
              name: this.#rmp.transcripts[i].name,
              uri: transcriptUri,
              default: defaultTranscript,
              data,
              html: ''
            };
            this.#rmp.dispatch('transcripttrackloaded');
            resolve();
          }
        }).catch(error => {
          this.#loadedTranscript[i] = {
            lng: '',
            name: '',
            uri: '',
            default: false,
            data: null,
            html: ''
          };
          this.#rmp.dispatch('transcripttrackloaderror');
          this.#rmp.rmpUtils.warning(4002, error);
          reject();
        });
    });
  }

  init() {
    if (this.#rmp.dom.containerParent.parentNode) {
      this.#rmp.dom.transcriptsContainer = this.#rmp.dom.containerParent.parentNode;
      this.#rmp.dom.transcriptsPlayerWrapper = this.#rmp.dom.transcriptsContainer.
        querySelector('.rmp-transcripts-player-wrapper');
      if (this.#rmp.dom.transcriptsContainer.classList.contains('rmp-transcripts-container') &&
        this.#rmp.dom.transcriptsPlayerWrapper) {
        const arrayTranscriptPromise = [];
        for (let i = 0, len = this.#rmp.transcripts.length; i < len; i++) {
          arrayTranscriptPromise[i] = this.#ajaxCall(i);
        }
        Promise.allSettled(arrayTranscriptPromise).then(values => {
          const found = values.find(value => value.status === 'rejected');
          if (found) {
            this.#rmp.rmpUtils.warning(5000);
          } else {
            Logger.print('captions', 'all transcript files loaded');
          }
          this.#loadedTranscript.forEach((transcript) => {
            this.#parseTranscriptsVtt(transcript);
          });
          this.#setUpTranscriptsUI();
        });
        return;
      }
    }
    this.#rmp.rmpUtils.error(800);
  }

}
